import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { Search } from "@mui/icons-material";
import { ToolLoadingProps, PropertyInsightsToolArgs } from "./toolLoadingRegistry";
import { BaseToolResult } from "./BaseToolResult";

export const PropertyInsightsLoading: React.FC<ToolLoadingProps> = ({
  args,
}) => {
  const typedArgs = args as PropertyInsightsToolArgs;
  const query = typedArgs?.query;

  return (
    <BaseToolResult icon="🏠">
      <Box
        sx={{
          borderRadius: 1,
          p: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
        >
          Researching Strata Property Documents
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <Search fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            Searching for: "{query}"
          </Typography>
        </Box>

        <LinearProgress
          sx={{
            borderRadius: 1,
            height: 4,
            backgroundColor: "primary.100",
          }}
        />
      </Box>
    </BaseToolResult>
  );
};
